<template>
  <LabelValue :label="t('Reviews.product.view.contact.label').toString()" data-testid="product-contact">
    <div class="grid grid-cols-2 gap-x-6">
      <div>
        <div class="pb-2 text-body-s-bold" data-testid="cta-primary-label">
          {{ t('Reviews.product.view.contact.primary.label') }}
        </div>
        <ChipBadge
          v-if="data.configFlags.ctaPrimaryActive"
          rounded
          color="success"
          :prepend-icon="iconDot"
          data-testid="cta-primary-status"
        >
          {{ t('Reviews.status.active') }}
        </ChipBadge>
        <ChipBadge v-else rounded :prepend-icon="iconDotOutline">{{ t('Reviews.status.hidden') }}</ChipBadge>
      </div>

      <div v-if="data.configFlags.ctaSecondaryActive">
        <div v-for="lang in ALLOWED_LOCALES" :key="lang" class="mb-4">
          <template v-if="data.ctaSecondaryLabelTranslationsMap[lang] && data.ctaSecondaryUrlTranslationsMap[lang]">
            <div class="mb-2 flex w-full items-center gap-x-2" data-testid="cta-secondary-label">
              <span class="text-body-s-bold">
                {{ t('Reviews.product.view.contact.secondary.label') }}
              </span>
              <ChipBadge class="uppercase" rounded>{{ lang }}</ChipBadge>
            </div>
            <div class="btn-outline-color-s pointer-events-none mb-2" data-testid="cta-secondary-btn">
              {{ data.ctaSecondaryLabelTranslationsMap[lang] }}
            </div>
            <div class="mt-2 mb-1 text-body-s-bold">
              {{ t('Reviews.product.view.contact.secondary.btnUrl') }}
            </div>
            <a
              class="block overflow-hidden text-ellipsis"
              :href="data.ctaSecondaryUrlTranslationsMap[lang]"
              target="_blank"
              data-testid="cta-secondary-url"
            >
              {{ data.ctaSecondaryUrlTranslationsMap[lang] }}
            </a>
          </template>
          <ChipBadge v-else rounded :prepend-icon="iconDotOutline">{{ t('Reviews.status.hidden') }}</ChipBadge>
        </div>
      </div>
      <div v-else>
        <ChipBadge rounded :prepend-icon="iconDotOutline">{{ t('Reviews.status.notSupported') }}</ChipBadge>
        <div class="mt-4 text-body-s" v-html="t('Reviews.product.view.contact.secondary.notSupported').toString()" />
      </div>
    </div>
  </LabelValue>
</template>
<script setup lang="ts">
import { ChipBadge, iconDot, iconDotOutline } from '@ramp106/omrjs-core-ui'
import { useI18n } from 'vue-i18n'

import { ALLOWED_LOCALES } from '@/helpers/translationsHelper.ts'
import LabelValue from '@/ui/LabelValue.vue'

defineProps<{
  data: {
    configFlags: {
      ctaPrimaryActive: boolean
      ctaSecondaryActive: boolean
    }
    ctaSecondaryLabelTranslationsMap: Record<string, string>
    ctaSecondaryUrlTranslationsMap: Record<string, string>
  }
}>()

const { t } = useI18n()
</script>
